import { render, staticRenderFns } from "./ValoresObtenidosForm.vue?vue&type=template&id=0453e128&"
import script from "./ValoresObtenidosForm.vue?vue&type=script&lang=ts&"
export * from "./ValoresObtenidosForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0453e128', component.options)
    } else {
      api.reload('0453e128', component.options)
    }
    module.hot.accept("./ValoresObtenidosForm.vue?vue&type=template&id=0453e128&", function () {
      api.rerender('0453e128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Alertas/ValoresObtenidosForm.vue"
export default component.exports